<template>
  <div id="property-projects" class="table-responsive">
    <table
      class="table table-sm table-striped table-hover table-bordered ledger"
    >
      <thead>
        <tr>
          <th scope="col">Project Name</th>
          <th scope="col">Benefitted Acres</th>
          <th scope="col">Initial Principal</th>
          <th scope="col">Balance</th>
          <th width="2" scope="col">&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(project, index) in projects"
          v-bind:key="index"
          class="w-100"
        >
          <td class="text-start">{{ project.Description }}</td>
          <td>{{ project.BenefittedAcres }}</td>
          <td>{{ project.InitialPrincipalAmount | currency }}</td>
          <td>{{ project.Balance | currency }}</td>
          <td class="px-2">
            <button
              type="button"
              class="btn btn-primary btn-sm w-100 d-print-none text-white shadow py-0 px-3"
              @click="
                loadProjectDetailsData(
                  project.PropertyProjectUID,
                  project.Description
                )
              "
              data-bs-toggle="modal"
              :data-bs-target="'#project-details-modal'"
            >
              Details
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <div
      class="modal fade"
      ref="cbmodal"
      id="project-details-modal"
      tabindex="-1"
      aria-labelledby="project-details-modal-label"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-scrollable modal-fullscreen-sm-down modal-xl"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="project-details-modal-label">
              Project Details
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="resetCurrentDetails"
            ></button>
          </div>
          <div class="modal-body pt-0">
            <div class="sticky-top w-100 bg-white">
              <p class="lead mb-2">{{ currentDescription }}</p>
              <div class="container border-bottom">
                <div class="row w-100">
                  <div
                    class="col fw-bolder d-flex justify-content-start align-items-end"
                  >
                    <span class="w-75">Receipt Amount</span>
                  </div>
                  <div
                    class="col fw-bolder d-flex justify-content-start align-items-end"
                  >
                    <span class="w-75">Transaction Date</span>
                  </div>
                  <div
                    class="col fw-bolder d-flex justify-content-start align-items-end"
                  >
                    <span class="w-75">Due Date</span>
                  </div>
                  <div
                    class="col fw-bolder d-flex justify-content-start align-items-end"
                  >
                    <span class="w-75">Prinicipal Balance Amount</span>
                  </div>
                  <div
                    class="col fw-bolder d-flex justify-content-start align-items-end"
                  >
                    <span class="w-75">Principal Amount Billed</span>
                  </div>
                  <div
                    class="col fw-bolder d-flex justify-content-start align-items-end"
                  >
                    <span class="w-75">Interest Amount</span>
                  </div>
                  <div
                    class="col fw-bolder d-flex justify-content-start align-items-end"
                  >
                    <span class="w-75">Current Penalty Amount</span>
                  </div>
                  <div
                    class="col fw-bolder d-flex justify-content-start align-items-end"
                  >
                    <span class="w-75">Annual Penalty Amount</span>
                  </div>
                  <div
                    class="col fw-bolder d-flex justify-content-start align-items-end"
                  >
                    <span class="w-75">Notes</span>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="loading || !currentDetails" class="m-5 p-5 text-center">
              Loading data...
            </div>
            <div
              v-if="!loading && currentDetails"
              class="container"
              id="modal-grid-table"
            >
              <div
                v-for="(detail, index) in currentDetails"
                v-bind:key="index"
                class="row w-100 p-2"
              >
                <div class="col">{{ detail.ReceiptAmount | currency }}</div>
                <div class="col">{{ detail.TransactionDate | toDate }}</div>
                <div class="col">{{ detail.DueDate | toDate }}</div>
                <div class="col">
                  {{ detail.PrincipalBalanceAmount | currency }}
                </div>
                <div class="col">
                  {{ detail.PrincipalAmountBilled | currency }}
                </div>
                <div class="col">{{ detail.InterestAmount | currency }}</div>
                <div class="col">
                  {{ detail.CurrentPenaltyAmount | currency }}
                </div>
                <div class="col">
                  {{ detail.AnnualPenaltyAmount | currency }}
                </div>
                <div class="col">{{ detail.Notes || "No Info" }}</div>
              </div>
              <div class="row w-100">
                <div class="col fw-bold">Totals:</div>
                <div class="col"></div>
                <div class="col"></div>
                <div class="col"></div>
                <div class="col"></div>
                <div class="col"></div>
                <div class="col"></div>
                <div class="col"></div>
                <div class="col"></div>
              </div>
              <div class="row w-100">
                <div class="col fw-bolder">{{ totals.ReceiptAmount | currency }}</div>
                <div class="col"></div>
                <div class="col"></div>
                <div class="col fw-bolder">
                  {{ totals.PrincipalBalanceAmount | currency }}
                </div>
                <div class="col fw-bolder">
                  {{ totals.PrincipalAmountBilled | currency }}
                </div>
                <div class="col fw-bolder">{{ totals.InterestAmount | currency }}</div>
                <div class="col fw-bolder">
                  {{ totals.CurrentPenaltyAmount | currency }}
                </div>
                <div class="col fw-bolder">
                  {{ totals.AnnualPenaltyAmount | currency }}
                </div>
                <div class="col"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
#modal-grid-table .row:nth-child(odd) {
  background: rgb(242, 242, 242);
}
#modal-grid-table .row:hover {
  background: rgb(230, 230, 230);
}
.col {
  background-color: transparent;
}
</style>
<script>
export default {
  data() {
    return {
      loading: true,
      cachedProjectDetails: {},
      currentDetails: null,
      currentDescription: null,
    };
  },
  methods: {
    resetCurrentDetails() {
      this.currentDetails = null;
      this.loading = true;
    },
    async loadProjectDetailsData(projectUID, projectDescription) {
      this.loading = true;
      if (projectUID in this.cachedProjectDetails) {
        this.currentDetails = this.cachedProjectDetails[projectUID];
        this.currentDescription = projectDescription;
        this.loading = false;
      } else {
        this.axios
          .get(process.env.VUE_APP_DATASERVICE + "GetPropertyProjectDetail", {
            params: {
              CorpCode: this.corpCode.toUpperCase(),
              PropertyProjectUID: projectUID,
              PayYear: this.$route.params.payYear,
            },
          })
          .then((response) => {
            this.cachedProjectDetails[projectUID] = response.data || [];
            this.currentDetails = response.data || [];
            this.currentDescription = projectDescription;
            this.loading = false;
          })
          .catch((err) => {
            console.error(
              `components/parcel/PropertyProjects fetch project details PropertyProjectUID: ${projectUID}`,
              err
            );
          });
      }
    },
  },
  computed: {
    totals() {
      const initial = {
        ReceiptAmount: 0,
        PrincipalBalanceAmount: 0,
        PrincipalAmountBilled: 0,
        InterestAmount: 0,
        CurrentPenaltyAmount: 0,
        AnnualPenaltyAmount: 0,
      };
      return this.currentDetails.reduce((a, b) => {
        return {
          ReceiptAmount: a.ReceiptAmount + b.ReceiptAmount,
          PrincipalBalanceAmount:
            a.PrincipalBalanceAmount + b.PrincipalBalanceAmount,
          PrincipalAmountBilled:
            a.PrincipalAmountBilled + b.PrincipalAmountBilled,
          InterestAmount: a.InterestAmount + b.InterestAmount,
          CurrentPenaltyAmount: a.CurrentPenaltyAmount + b.CurrentPenaltyAmount,
          AnnualPenaltyAmount: a.AnnualPenaltyAmount + b.AnnualPenaltyAmount,
        };
      }, initial);
    },
  },
  props: {
    projects: {
      type: Array,
      required: true,
    },
    corpCode: {
      type: String,
      required: true,
    },
  },
};
</script>
